import ApiCalls from "../../config/apiCalls";
import Location from "../../config/location";
import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";
import { keyMapsAction } from "../../helpers/storeKeys";
import {
  projectBasePathWithFolder,
  v2PwaBasePath,
} from "../../config/apiEndpoints";
import { MINIAPP, ORDER_TYPE } from "../../helpers/paymentConstants";
import gpayMicroapp from "../../helpers/gpayMicroapp";
import paytmMicroapp from "../../helpers/paytmMicroapp";
import {
  redirectToMapScreenAfterSeconds,
  shouldHideCompleteLocationFlow,
  shouldFetchLocationFromIp,
} from "../../config/apiEndpoints";
import setEvents from "../../helpers/events";

const storeNotFound = function (commit) {
  if (
    !Utility.checkWindowLocationIncludes(
      Utility.getCurrentStoreFolder() + Location.defaultStoreId,
    )
  ) {
    LocalStorageFunc.unsetSessionStorageKey("noDeliveryLocation");
    window.location.href =
      projectBasePathWithFolder +
      Utility.getCurrentStoreFolder() +
      Location.defaultStoreId +
      Utility.getUrlQueryString();
  }
  commit("updateStoreNotFound", {});
};

const afterStoreApiSuccess = function (stores, commit, dispatch) {
  if (
    !Utility.checkWindowLocationIncludes(
      Utility.getCurrentStoreFolder() + stores.id,
    ) &&
    !Utility.isNoRedirectTrue()
  ) {
    commit("updateIsLocationSettled", {});
    setTimeout(() => {
      window.location.href =
        projectBasePathWithFolder +
        Utility.getCurrentStoreFolder() +
        stores.id +
        Utility.getUrlQueryString();
    }, 2000);
    return;
  } else {
    commit("updateIsLocationSettled", {});
  }

  /* stores.data.data.online = 0;
  stores.data.data.startTime = "16:00"; */
  commit("updateStoreDetails", stores);
  commit("updateHomePageAddress", stores);
  commit("updateNearestApiTopAddress", stores.city);
  if (!stores.online) {
    dispatch("locatorStoreTakeawayDineInAvailabilityApi", {});
  }

  dispatch(keyMapsAction.WELCOME_OFFER_API, {}, { root: true });
  // dispatch(keyMapsAction.PIZZA_TOPPING_API, {}, { root: true });
};

const updateLocalLocationAfterStoreApi = function (stores, commit, payload) {
  LocalStorageFunc.updateStoreId(stores.id);
  commit("updateLocationFromGeoCodeApiCombo", {
    address_alias: Utility.getAddressAlias(stores),
    complete_address:
      LocalStorageFunc.getDeliveryType() != "D"
        ? stores?.name || ""
        : stores?.homePageAddress?.bottomAddress ||
          stores?.displayAddress ||
          "",
    lastLocationObjectforLocalStorage: {
      recent: stores,
      location: {
        latitude: stores.addressComponent?.latitude || stores.latitude,
        longitude: stores.addressComponent?.longitude || stores.longitude,
        addressRequired: true,
      },
      deliveryType: LocalStorageFunc.getDeliveryType(),
      source: payload.source,
    },
    isTrueLocationDetected: payload.source == "ip" ? false : true,
  });
};

const logNghLocationEvent = (locationType, storeID, isQrOrderFlow = false) => {
  let preObj = {
    locationType,
    storeID,
  };
  if (isQrOrderFlow) {
    preObj = {
      ...preObj,
      sectionName: "QR Order",
      screenName: "QR Order Page",
      Page_Name: "QR Order Page",
    };
  }
  const eventObj = Utility.amplitudeEventObj(
    "nghLocation",
    isQrOrderFlow ? "QR order" : undefined,
    undefined,
    preObj,
  );
  setEvents("amplitude", "nghLocation", eventObj);
};

export default {
  namespaced: true,
  state: {
    isTrueLocationDetected: Utility.isStoreUrlCacheEligible()
      ? LocalStorageFunc.getIsTrueLocationDetected()
      : false,
    locationData: Utility.isStoreUrlCacheEligible()
      ? LocalStorageFunc.getComputedLocationData()
      : false,
    isHomePageAddressAvailable: false,
    storeStartTime: "00:00",
    takeawayStoreList: [],
    takeawayDineAvailability: {
      TAKEAWAY: false,
      DINEIN: false,
    },
    storeNotFound: false,
    currentLocationUnservicable: false,
    noDeliveryZoneData: {},
    isLocationSettled: false,
    storeDetails: {
      online: 1,
    },
    showLocationAccessBlockedModal: false,
    isNearestApiSuccessful: false,
    nearestApiTopAddress: Utility.isStoreUrlCacheEligible()
      ? LocalStorageFunc.nearestApiTopAddress()
      : "",
    showLocationLoading: false,
    locationType: "default",
    isLocatorStoreTakeawayDineInAvailabilityApiInProgress: false,
    isLocationPermissionGiven: LocalStorageFunc.getIsLocationPermisssionGiven(),
    childStoreId: "",
    showLocationPermissionModalShimmerStore: true,
    cachedStoreApiLoaded: false,
    isQrOrderFlow: false,
  },
  getters: {},
  mutations: {
    updateLocationFromGeoCodeApiCombo(state, payload) {
      state.isTrueLocationDetected = payload.isTrueLocationDetected;
      LocalStorageFunc.setIsTrueLocationDetected(
        payload.isTrueLocationDetected,
      );
      state.locationData = {
        address_alias: payload.address_alias,
        complete_address: payload.complete_address,
      };
      LocalStorageFunc.setComputedLocationData(state.locationData);
      LocalStorageFunc.updateLastLocation(
        payload.lastLocationObjectforLocalStorage,
      );
    },
    updateLocationFromLocalStorage(state, payload) {
      state.isTrueLocationDetected = payload.isTrueLocationDetected;
      LocalStorageFunc.setIsTrueLocationDetected(
        payload.isTrueLocationDetected,
      );
      state.locationData = payload.data;
      LocalStorageFunc.setComputedLocationData(payload.data);
    },
    resetLocationtate(state, payload) {
      state.isTrueLocationDetected = false;
      LocalStorageFunc.unsetSessionStorageKey("isTrueLocationDetected");
      state.locationData = {};
      LocalStorageFunc.setComputedLocationData({});
      state.isLocationSettled = true;
      state.isHomePageAddressAvailable = false;
    },
    updateTakeAwayStoresList(state, payload) {
      state.takeawayStoreList = payload;
    },
    updateStoreNotFound(state, payload) {
      state.storeNotFound = true;
      state.isLocationSettled = true;
    },
    updateTakeawayDineAvailability(state, payload) {
      state.takeawayDineAvailability.TAKEAWAY = payload.TAKEAWAY || false;
      state.takeawayDineAvailability.DINEIN = payload.DINEIN || false;
    },
    updateCurrentLocationUnservicable(state, payload) {
      state.currentLocationUnservicable = payload;
    },
    updateNoDeliveryZoneData(state, payload) {
      state.noDeliveryZoneData = payload;
    },
    updateIsLocationSettled(state, payload) {
      state.isLocationSettled = true;
      LocalStorageFunc.setIsStoreIdCacheEligible();
    },
    resetIsLocationSettled(state, payload) {
      state.isLocationSettled = false;
      LocalStorageFunc.unsetSessionStorageKey("isStoreIdCacheEligible");
    },
    updateStoreDetails(state, payload) {
      if (payload.startTime && !(payload.startTime instanceof Object)) {
        let hour = +payload.startTime.split(":")[0] || 0;
        let minute = +payload.startTime.split(":")[1];
        payload.startTime = {
          hour: hour > 12 ? hour - 12 : hour,
          minute: minute,
          amOrPm: hour > 12 ? "pm" : "am",
          advanceOrderApplicable:
            new Date().getHours() < hour ||
            (new Date().getHours() == hour && new Date().getMinutes() < minute),
        };
      } else {
        payload.startTime = {
          advanceOrderApplicable: false,
        };
      }
      const source = LocalStorageFunc.getLocationSource();
      const storeID = LocalStorageFunc.storeId();
      const coords = LocalStorageFunc.getCoordsFromRecentLocation();
      let locationType = "default";
      if (coords?.coords) {
        if (source === "ip") {
          locationType = "ip";
        } else {
          locationType = "gps";
        }
      }
      state.locationType = locationType;
      logNghLocationEvent(locationType, storeID, state.isQrOrderFlow);
      state.storeDetails = payload;
    },
    updateShowLocationAccessBlockedModal(state, payload) {
      state.showLocationAccessBlockedModal = payload;
    },
    updateHomePageAddress(state, payload) {
      state.locationData = {
        address_alias: Utility.getAddressAlias(payload),
        complete_address:
          LocalStorageFunc.getDeliveryType() != "D"
            ? payload?.name || ""
            : payload?.homePageAddress?.bottomAddress ||
              payload?.displayAddress ||
              "",
      };
      state.isHomePageAddressAvailable = true;
      LocalStorageFunc.setComputedLocationData(state.locationData);
    },
    updateNearestApiTopAddress(state, payload) {
      state.nearestApiTopAddress = payload;
      LocalStorageFunc.setNearestApiTopAddress(payload);
    },
    updateShowLocationLoading(state, payload) {
      state.showLocationLoading = payload;
    },
    updateIsLocatorStoreTakeawayDineInAvailabilityApiInProgress(
      state,
      payload,
    ) {
      state.isLocatorStoreTakeawayDineInAvailabilityApiInProgress = payload;
    },
    updateIsLocationPermisssionGiven(state, payload) {
      state.isLocationPermissionGiven = payload;
    },
    updateChildStoreId(state, payload) {
      state.childStoreId = payload;
    },
    updateShowLocationPermissionModalShimmerStore(state, payload) {
      state.showLocationPermissionModalShimmerStore = payload;
    },
    updateCachedStoreApiLoaded(state, payload) {
      state.cachedStoreApiLoaded = payload;
    },
    updateQrOrderFlow(state, payload) {
      state.isQrOrderFlow = payload;
    },
  },
  actions: {
    detectGeoLocationPopup({ commit, dispatch }, payload) {
      const isMiniApp = Utility.getMiniAppStorageVal();
      if (
        payload.source == "locationPopupBanner" ||
        !Utility.isStoreUrlCacheEligible()
      ) {
        commit("resetIsLocationSettled", {});
        LocalStorageFunc.unsetSessionStorageKey("isStoreIdCacheEligible");
      }
      // if (isMiniApp === MINIAPP.PAYTM) {
      //   console.log('PAYTM MINIAPP');
      //   const result = paytmMicroapp.getLocation();
      //   console.log('RESULT', result);
      //   if(result?.err) {
      //     console.error('Error in Paytm: ', result.err);
      //   }
      //   else {
      //     dispatch("geoCodeApiCombo", result);
      //   }
      // }
      if (isMiniApp === MINIAPP.GPAY) {
        gpayMicroapp.getCurrentLocation((err, result) => {
          if (err) {
            console.error("Error in Google Pay: ", err);
            payload.showModalM();
          } else {
            const data = { coords: result };
            dispatch("geoCodeApiCombo", data);
          }
        });
      } else if (navigator.geolocation) {
        commit("updateShowLocationLoading", true);
        navigator.geolocation.getCurrentPosition(
          (data) => {
            LocalStorageFunc.setIsLocationPermissionGiven();
            commit("updateIsLocationPermisssionGiven", true);
            dispatch("geoCodeApiCombo", data);
          },
          (error) => {
            commit("updateIsLocationPermisssionGiven", false);
            LocalStorageFunc.unsetKey("isLocationPermissionGiven");
            if (!shouldHideCompleteLocationFlow) {
              LocalStorageFunc.setAskLocationLaterInSession();
            }
            if (
              payload.source == "locationPopup" ||
              payload.source == "locationPopupBanner"
            ) {
              payload.showModalM();
            } else if (!shouldHideCompleteLocationFlow) {
              dispatch("googleGeoLocationApi", error);
            } else {
              commit("updateShowLocationLoading", false);
            }
          },
          Location.geoLocationOptions,
        );
      } else {
        commit("resetLocationtate", {});
      }
    },
    googleGeoLocationApi({ commit, dispatch }, payload) {
      if (shouldFetchLocationFromIp) {
        ApiCalls.GOOGLE_GEOLOCATION_API({
          headers: {},
          payload: {
            considerIp: true,
          },
        })
          .then(function (response) {
            if (response?.data?.location?.lat) {
              dispatch("nearestStoreApi", {
                coords: {
                  latitude: response.data.location.lat,
                  longitude: response.data.location.lng,
                },
                source: "ip",
              });
            } else {
              commit("updateShowLocationLoading", false);
              dispatch("loadRecentLocationFromLocalStorage");
            }
          })
          .catch(function (error) {
            dispatch("loadRecentLocationFromLocalStorage");
          });
      } else {
        commit("updateShowLocationLoading", false);
        dispatch("loadRecentLocationFromLocalStorage");
      }
    },
    storeDetailsApi({ commit, dispatch }, payload) {
      ApiCalls.STORE_DETAILS_API({
        headers: Headers(),
        payload: payload,
      })
        .then(function (response) {
          if (response?.data) {
          } else {
          }
        })
        .catch(function (error) {});
    },

    cachedStoreApi({ commit, dispatch }, payload = {}) {
      if (payload.qrOrderFlow) {
        commit("updateQrOrderFlow", true);
      } else {
        commit("updateQrOrderFlow", false);
      }
      Promise.all([
        ApiCalls.STORE_DETAILS_API({
          headers: Headers(),
          payload: {
            storeId: payload.storeId,
          },
        }),
      ])
        .then(async ([stores]) => {
          if (stores?.data?.data?.id) {
            const lastLocation = Utility.tryJsonParse(
              localStorage.lastLocationNew,
            );
            if (lastLocation && lastLocation[0]?.recent?.homePageAddress) {
              stores.data.data.homePageAddress =
                lastLocation[0].recent.homePageAddress;
            }
            const {
              chatbotPriority,
              chatbotVersion,
              allowedDeliveryTypeCodes = [],
            } = stores?.data?.data || {};
            const chatbotVariant = sessionStorage.getItem("CHATBOT_VARIANT");
            if (chatbotPriority && chatbotPriority !== chatbotVariant) {
              sessionStorage.setItem("CHATBOT_VARIANT", chatbotVersion);
            }
            const selectedOrderType = LocalStorageFunc.getDeliveryType();
            if (
              payload.qrOrderFlow &&
              selectedOrderType.toLowerCase() ===
                ORDER_TYPE.PICKUP.toLowerCase()
            ) {
              const index = allowedDeliveryTypeCodes?.findIndex(
                (item) =>
                  item.toLowerCase() === selectedOrderType.toLowerCase(),
              );
              if (index === -1) {
                LocalStorageFunc.setDeliveryType(ORDER_TYPE.DINEIN);
              }
            }
            commit("updateStoreDetails", stores.data.data);
            commit("updateHomePageAddress", stores.data.data);
            commit("updateIsLocationSettled", {});
            commit("updateNearestApiTopAddress", stores.data.data.city);
            updateLocalLocationAfterStoreApi(stores.data.data, commit, payload);
            if (!payload.qrOrderFlow && !stores.data.data.online) {
              dispatch("locatorStoreTakeawayDineInAvailabilityApi", {});
            }
          } else if (payload.qrOrderFlow) {
            throw new Error(stores || "no data");
          }
        })
        .catch((error) => {
          if (payload.qrOrderFlow) {
            localStorage.removeItem("lastLocationNew");
            localStorage.removeItem("selectedAddress");
            LocalStorageFunc.setComputedLocationData({});
          }
        })
        .finally((e) => {
          commit("updateCachedStoreApiLoaded", true);
          if (payload.qrOrderFlow) {
            LocalStorageFunc.setIsTrueLocationDetected(true);
          }
        });
    },
    updateCachedStoreData({ commit, dispatch }, payload) {
      const recentLastLocation = Utility.tryJsonParse(
        localStorage.lastLocationNew,
      )[0]?.recent;
      if (
        payload.storeId === recentLastLocation?.id &&
        !Utility.isPageReloaded()
      ) {
        commit("updateStoreDetails", recentLastLocation);
        commit("updateHomePageAddress", recentLastLocation);
        commit("updateIsLocationSettled", {});
        commit("updateNearestApiTopAddress", recentLastLocation.city);
        updateLocalLocationAfterStoreApi(recentLastLocation, commit, payload);
        if (!recentLastLocation.online) {
          dispatch("locatorStoreTakeawayDineInAvailabilityApi", {});
        }
      } else {
        dispatch("cachedStoreApi", payload);
      }
    },

    nearestStoreApi({ commit, dispatch }, payload) {
      let delType = localStorage.userInfo
        ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.deliveryType ||
          "D"
        : "D";

      Promise.all([
        ApiCalls.NEAREST_STORE_API({
          headers: Headers(),
          payload: {
            latitude: payload.coords.latitude,
            longitude: payload.coords.longitude,
            addressRequired: true,
          },
        }),
      ])
        .then(async ([stores]) => {
          commit("updateShowLocationLoading", false);

          if (stores?.data?.data?.id) {
            payload.source = "ip";
            updateLocalLocationAfterStoreApi(stores.data.data, commit, payload);
            afterStoreApiSuccess(stores.data.data, commit, dispatch);
            commit("updateNearestApiTopAddress", stores.data.data.city);

            let { addressComponent = {} } = stores?.data?.data || {};
            const userlocation = {
              location: {
                latitude:
                  payload.coords.latitude || addressComponent?.latitude || "",
                longitude:
                  payload.coords.longitude || addressComponent?.longitude || "",
              },
            };

            if (delType === "D") {
              LocalStorageFunc.setUserLocationData(userlocation);
            }
          } else {
            if (delType === "D") {
              LocalStorageFunc.setUserLocationData("");
            }
            storeNotFound(commit);
          }
        })
        .catch((errors) => {
          if (delType === "D") {
            LocalStorageFunc.setUserLocationData("");
          }
          dispatch("loadRecentLocationFromLocalStorage");
        });
    },

    geoCodeApiCombo({ commit, dispatch, rootGetters }, payload) {
      let delType = localStorage.userInfo
        ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.deliveryType ||
          "D"
        : "D";

      Promise.all([
        ApiCalls.LOCATOR_STORES_V3_API({
          headers: Headers(),
          payload: {
            latitude: payload.coords.latitude,
            longitude: payload.coords.longitude,
          },
        }),
      ])
        .then(async ([response]) => {
          // save chatbot priority
          const { chatbotPriority, chatbotVersion } =
            response?.data?.storeData || {};
          const chatbotVariant = sessionStorage.getItem("CHATBOT_VARIANT");
          if (chatbotPriority && chatbotPriority !== chatbotVariant) {
            sessionStorage.setItem("CHATBOT_VARIANT", chatbotVersion);
          }
          commit("updateShowLocationLoading", false);
          let noDeliveryZoneD = {
            location: {
              latitude: payload.coords.latitude,
              longitude: payload.coords.longitude,
            },
            displayText:
              (response?.data?.geoCodeData &&
                response?.data?.geoCodeData?.displayAddress) ||
              "",
          };
          if (!response?.data?.storeData?.id) {
            commit("updateNoDeliveryZoneData", noDeliveryZoneD);
          }

          let { addressComponent = {} } = response?.data?.storeData || {};
          let userlocation = {
            location: {
              latitude:
                payload.coords.latitude || addressComponent?.latitude || "",
              longitude:
                payload.coords.longitude || addressComponent?.longitude || "",
            },
          };

          if (response?.data?.storeData?.id) {
            if (
              payload.source == "ip" &&
              LocalStorageFunc.storeId() == Location.defaultStoreId
            ) {
              LocalStorageFunc.setHideLocationPopupOnceInSession();
            }
            updateLocalLocationAfterStoreApi(
              response.data.storeData,
              commit,
              payload,
            );
            afterStoreApiSuccess(response.data.storeData, commit, dispatch);

            const childStoreId = response?.data?.storeData?.childStoreId || "";
            commit("updateChildStoreId", childStoreId);
            LocalStorageFunc.setLocalStorageValue(
              "CHILD_STORE_ID_IS",
              childStoreId,
            );
            if (delType === "D") {
              LocalStorageFunc.setUserLocationData(userlocation);
            }
          } else if (
            LocalStorageFunc.storeId() == Location.defaultStoreId &&
            !LocalStorageFunc.getReturnedFromMapScreen()
          ) {
            LocalStorageFunc.setNoDeliveryZoneInSession(noDeliveryZoneD);
            LocalStorageFunc.setReturnedFromMapScreen();
            LocalStorageFunc.setLocalStorageValue("CHILD_STORE_ID_IS", "");
            if (delType === "D") {
              LocalStorageFunc.setUserLocationData("");
            }
            setTimeout(() => {
              window.location.href = `${v2PwaBasePath}/mapScreen?isFromHome=true&latitude=${payload.coords.latitude}&longitude=${payload.coords.longitude}`;
            }, redirectToMapScreenAfterSeconds * 1000);
            return;
          } else {
            let payload2 = LocalStorageFunc.getCoordsFromRecentLocation();
            if (payload2) {
              await ApiCalls.LOCATOR_STORES_V3_API({
                headers: Headers(),
                payload: {
                  latitude: payload2.coords.latitude,
                  longitude: payload2.coords.longitude,
                },
              })
                .then(async function (response) {
                  // save chatbot priority
                  const { chatbotPriority, chatbotVersion } =
                    response?.data?.storeData || {};
                  const chatbotVariant =
                    sessionStorage.getItem("CHATBOT_VARIANT");
                  if (chatbotPriority && chatbotPriority !== chatbotVariant) {
                    sessionStorage.setItem("CHATBOT_VARIANT", chatbotVersion);
                  }
                  if (response?.data?.storeData?.id) {
                    commit("updateCurrentLocationUnservicable", true);

                    const childStoreId =
                      response?.data?.storeData?.childStoreId || "";
                    commit("updateChildStoreId", childStoreId);
                    LocalStorageFunc.setLocalStorageValue(
                      "CHILD_STORE_ID_IS",
                      childStoreId,
                    );

                    if (delType === "D") {
                      let { addressComponent = {} } =
                        response?.data?.storeData || {};
                      let userlocation = {
                        location: {
                          latitude:
                            payload2.coords.latitude ||
                            addressComponent?.latitude ||
                            "",
                          longitude:
                            payload2.coords.longitude ||
                            addressComponent?.longitude ||
                            "",
                        },
                      };
                      LocalStorageFunc.setUserLocationData(userlocation);
                    }

                    if (LocalStorageFunc.isLocationSelectedFromPwaV2) {
                      LocalStorageFunc.unsetSessionStorageKey(
                        "lastLocationNewSource",
                      );
                    } else {
                      LocalStorageFunc.setLocationSelectedFromPwaV2();
                    }
                    if (
                      !Utility.checkWindowLocationIncludes(
                        Utility.getCurrentStoreFolder() +
                          response.data.storeData.id,
                      )
                    ) {
                      window.location.href =
                        projectBasePathWithFolder +
                        Utility.getCurrentStoreFolder() +
                        response.data.storeData.id +
                        Utility.getUrlQueryString();
                    } else {
                      updateLocalLocationAfterStoreApi(
                        response.data.storeData,
                        commit,
                        payload,
                      );
                      afterStoreApiSuccess(
                        response.data.storeData,
                        commit,
                        dispatch,
                      );
                    }
                  } else {
                    storeNotFound(commit);
                  }
                })
                .catch(async function (error) {
                  LocalStorageFunc.setLocalStorageValue(
                    "CHILD_STORE_ID_IS",
                    "",
                  );
                  if (delType === "D") {
                    LocalStorageFunc.setUserLocationData("");
                  }
                  storeNotFound(commit);
                });
            } else {
              LocalStorageFunc.setLocalStorageValue("CHILD_STORE_ID_IS", "");
              dispatch("googleGeoLocationApi");
            }
          }
        })
        .catch((errors) => {
          if (delType === "D") {
            LocalStorageFunc.setUserLocationData("");
          }
          LocalStorageFunc.setLocalStorageValue("CHILD_STORE_ID_IS", "");
          return errors;
          //dispatch("loadRecentLocationFromLocalStorage");
        });
    },

    loadRecentLocationFromLocalStorage({ commit, dispatch }, payload) {
      let value = localStorage.lastLocationNew
        ? Utility.tryJsonParse(localStorage.lastLocationNew)[0]?.recent
        : "";

      if (value) {
        commit("updateLocationFromLocalStorage", {
          isTrueLocationDetected:
            Utility.calculateIsTrueLocationDetectedFromLocationSource(),
          data: {
            address_alias: Utility.getAddressAlias(),
            complete_address:
              value.homePageAddress?.bottomAddress ||
              value.displayAddress ||
              "",
          },
        });
        commit("updateIsLocationSettled", {});
      } else {
        if (
          !Utility.checkWindowLocationIncludes(
            Utility.getCurrentStoreFolder() + Location.defaultStoreId,
          )
        ) {
          window.location.href =
            projectBasePathWithFolder +
            Utility.getCurrentStoreFolder() +
            Location.defaultStoreId +
            Utility.getUrlQueryString();
        }
        commit("resetLocationtate", {});
      }
    },

    loadRecentLocationFromLocalStorageForIp({ commit, dispatch }, payload) {
      let value = localStorage.lastLocationNewForIp
        ? Utility.tryJsonParse(localStorage.lastLocationNewForIp)[0]?.recent
        : "";

      if (value) {
        commit("updateLocationFromLocalStorage", {
          isTrueLocationDetected:
            Utility.calculateIsTrueLocationDetectedFromLocationSource(),
          data: {
            address_alias: Utility.getAddressAlias(),
            complete_address: value.city || value.displayAddress || "",
          },
        });
        commit("updateIsLocationSettled", {});
      } else {
        if (Utility.shouldRedirectToCategory()) {
          window.location.href =
            projectBasePathWithFolder +
            Utility.getCurrentStoreFolder() +
            Location.defaultStoreId +
            Utility.getUrlQueryString();
        }
        commit("resetLocationtate", {});
      }
    },

    loadRecentLocationFromLocalStorageForIp({ commit, dispatch }, payload) {
      let value = localStorage.lastLocationNewForIp
        ? Utility.tryJsonParse(localStorage.lastLocationNewForIp)[0]?.recent
            ?.displayAddress
        : "";

      if (value) {
        commit("updateLocationFromLocalStorage", {
          isTrueLocationDetected:
            Utility.calculateIsTrueLocationDetectedFromLocationSource(),
          data: {
            address_alias: Utility.getAddressAlias(),
            complete_address: value,
          },
        });
        commit("updateIsLocationSettled", {});
      } else {
        if (
          !Utility.checkWindowLocationIncludes(
            Utility.getCurrentStoreFolder() + Location.defaultStoreId,
          )
        ) {
          window.location.href =
            projectBasePathWithFolder +
            Utility.getCurrentStoreFolder() +
            Location.defaultStoreId +
            Utility.getUrlQueryString();
        }
        commit("resetLocationtate", {});
      }
    },

    locatorStoreTakeawayApi({ commit, dispatch }, payload) {
      let value = LocalStorageFunc.getCoordsFromRecentLocation();
      ApiCalls.LOCATOR_STORES_TAKEAWAY_API({
        headers: Headers(),
        payload: {
          latitude: value?.coords?.latitude,
          longitude: value?.coords?.longitude,
          orderType: payload || "P",
        },
      })
        .then(function (response) {
          if (
            response?.data?.status == "SUCCESS" &&
            response?.data?.storeStationDetails.length > 0
          ) {
            commit(
              "updateTakeAwayStoresList",
              response.data.storeStationDetails,
            );
          } else {
            commit("updateTakeAwayStoresList", []);
          }
        })
        .catch(function (error) {
          commit("updateTakeAwayStoresList", []);
        });
    },

    locatorStoreTakeawayDineInAvailabilityApi({ commit, dispatch }, payload) {
      let value = LocalStorageFunc.getCoordsFromRecentLocation();
      commit(
        "updateIsLocatorStoreTakeawayDineInAvailabilityApiInProgress",
        true,
      );
      ApiCalls.LOCATOR_STORES_TAKEAWAY_API({
        headers: Headers(),
        payload: {
          latitude: value?.coords?.latitude,
          longitude: value?.coords?.longitude,
          orderType: "P%2CCURB%2CDINEIN",
          extra: "distanceRequired=false",
        },
      })
        .then(function (response) {
          if (
            response?.data?.status == "SUCCESS" &&
            response?.data?.storeStationDetails.length > 0
          ) {
            let TAKEAWAY = false,
              DINEIN = false;
            response.data.storeStationDetails.map((_) => {
              _.store.stations.map((__) => {
                if (
                  __.status &&
                  __.operational &&
                  __.deliveryTypeCode == "DINEIN"
                ) {
                  DINEIN = true;
                }
                if (
                  __.status &&
                  __.operational &&
                  (__.deliveryTypeCode == "P" || __.deliveryTypeCode == "CURB")
                ) {
                  TAKEAWAY = true;
                }
              });
            });
            commit("updateTakeawayDineAvailability", {
              TAKEAWAY: TAKEAWAY,
              DINEIN: DINEIN,
            });
          } else {
            commit("updateTakeawayDineAvailability", {});
          }
        })
        .catch(function (error) {
          commit("updateTakeawayDineAvailability", {});
        })
        .finally(function () {
          commit(
            "updateIsLocatorStoreTakeawayDineInAvailabilityApiInProgress",
            false,
          );
        });
    },
  },
};
